import { Box, Typography } from "@mui/material";
import Loading from "components/common/Loading";
import AnnotationCard from "components/engagement/notes/AnnotationCard";
import { AdvisorApplication } from "../../protogen/advisor_pipeline_service_pb";
import { ReactNode, useEffect } from "react";
import {
  useListAdvisorAnnotations,
  useUpdateAdvisorAnnotation,
} from "services/admin";
import AddAdvisorAnnotation from "../admin/AddAdvisorAnnotation";
import { ListAdvisorAnnotationsRequest } from "protogen/admin_service_pb";

type Props = {
  application: AdvisorApplication;
};

export default ({ application }: Props) => {
  const { data: annotations, loading, request } = useListAdvisorAnnotations();
  const { request: deleteAnnotation } = useUpdateAdvisorAnnotation();

  const refresh = async () => {
    await request(
      new ListAdvisorAnnotationsRequest({
        advisorRef: application.advisorRef,
        applicationRef: application.ref,
      }),
    );
  };

  useEffect(() => {
    refresh();
  }, [application.ref]);

  // Merge results
  const feedEntries: [number, ReactNode][] = [
    ...(annotations?.annotations || []).map(
      (annotation): [number, ReactNode] => [
        Number(annotation.lastUpdatedSec),
        <AnnotationCard
          key={`annotation-${annotation.ref}`}
          annotation={annotation}
          handleDelete={async () => {
            await deleteAnnotation({
              annotationRef: annotation.ref,
              delete: true,
            });
            await refresh();
          }}
        />,
      ],
    ),
  ];
  feedEntries.sort((a, b) => b[0] - a[0]);
  const getNoteTypes = () => {
    switch (application.status.toLowerCase()) {
      case "in_review":
        return ["application-review", "note", "screen", "task-test"];
      case "interview":
        return ["screen", "note", "application-review", "task-test"];
      case "ttt_sent":
        return ["task-test", "note", "application-review", "screen"];
      case "onboarding":
      default:
        return ["note", "application-review", "screen", "task-test"];
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="bodyHeavy">Notes</Typography>
      </Box>
      <AddAdvisorAnnotation
        applicationRef={application.ref}
        placeholder="Add a note"
        noteTypes={getNoteTypes()}
        includeFlags={false}
        forceOpen={false}
        onUpdate={refresh}
      />
      {loading && <Loading />}
      {feedEntries.map((entry) => entry[1])}
    </Box>
  );
};
